import api from "@/lib/api";

// Request identity, never an authentication token. Persist before POST; an
// ambiguous outcome or status 404 never permits forgetting a paid operation.
const slot = (user, action) => `op_ai_v1:${user?.id}:${user?.workspace_id || "personal"}:${action}`;
export function storedAI(user, action) {
  const raw = localStorage.getItem(slot(user, action));
  if (!raw) return null;
  const r = JSON.parse(raw);
  if (!r || typeof r.id !== "string" || typeof r.state !== "string" || !r.parameters) throw new Error("Identité IA locale illisible : nouvelle génération refusée.");
  return r;
}
function write(user, action, record) { localStorage.setItem(slot(user, action), JSON.stringify(record)); }
const terminal = (r) => r?.state === "completed" || r?.can_retry === true || (r?.state === "not_admitted" && r?.admission === "not_admitted");
export async function refreshAI(user, action) {
  const old = storedAI(user, action);
  if (!old) throw new Error("Aucune identité IA à consulter.");
  const { data } = await api.get(`/ai/operations/${encodeURIComponent(old.id)}`);
  if (data?.id !== old.id || typeof data.state !== "string") throw new Error("État IA invalide : conserver l’identité.");
  if (storedAI(user, action)?.id === old.id) write(user, action, { ...old, ...data });
  return data;
}
export async function submitAI(user, action, path, parameters, { standard = false } = {}) {
  if (standard) return (await api.post(path, parameters)).data;
  const old = storedAI(user, action);
  if (old && !terminal(old) && JSON.stringify(old.parameters) !== JSON.stringify(parameters)) throw new Error("Une génération IA non résolue possède d’autres paramètres. Consultez son état avant de changer la demande.");
  const record = old && !terminal(old) ? old : { id: crypto.randomUUID(), parameters, state: "pending" };
  write(user, action, record);
  try {
    const { data } = await api.post(path, parameters, { headers: { "Idempotency-Key": record.id } });
    if (storedAI(user, action)?.id === record.id) write(user, action, { ...record, state: "completed" });
    return data;
  } catch (error) {
    // Only a read. Never replay a POST on errors, reload or status refresh.
    try { await refreshAI(user, action); } catch (_) { /* uncertainty retains identity */ }
    throw error;
  }
}
